import { render, staticRenderFns } from "./StudentArchive.vue?vue&type=template&id=80842564&scoped=true"
import script from "./StudentArchive.vue?vue&type=script&lang=js"
export * from "./StudentArchive.vue?vue&type=script&lang=js"
import style0 from "./StudentArchive.vue?vue&type=style&index=0&id=80842564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80842564",
  null
  
)

export default component.exports